import { render, staticRenderFns } from "./ModalCompartilhamentoRelatorioRastreabilidade.vue?vue&type=template&id=0f571418&lang=pug"
import script from "./ModalCompartilhamentoRelatorioRastreabilidade.vue?vue&type=script&lang=js"
export * from "./ModalCompartilhamentoRelatorioRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./ModalCompartilhamentoRelatorioRastreabilidade.vue?vue&type=style&index=0&id=0f571418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports